/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { AddressProps, AddressDefaults } from './address';

export const ShippingProps = PropTypes.shape({
    Method: PropTypes.string,
    Cost: PropTypes.number,
    Address: AddressProps,
});

export const ShippingDefaults = {
    Method: '',
    Cost: '',
    Address: AddressDefaults,
};
